import React from "react";
import AuswertungComponent from "../components/auswertung/AuswertungComponent";

function SystemVerwaltungView({history, location}) {

    return (
        <div
            style={ {
                overflow: "auto",
                maxHeight: "100%",
            } }
        >
            <AuswertungComponent history={ history } location={ location }/>
        </div>
    );
}

export default SystemVerwaltungView;
